import { render } from "./QuotationDetails.vue?vue&type=template&id=010ca9d6"
import script from "./QuotationDetails.vue?vue&type=script&lang=js"
export * from "./QuotationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__